import React from 'react';
import { DataContent, DataLayer } from '../../components/DataLayer';
import { Column, Row } from '../../components/Grid';
import { HtmlContent } from '../../components/layout/HtmlContent';
import NavigationGroup from '../../components/layout/NavigationGroup';
import {
  Navigation,
  NavigationHeader,
  NavigationLink,
  NavigationList
} from '../../components/Navigation';
import { LayerContent } from '../../provider/Typo3Provider/types';

interface DataLayerContainerProps {
  layer: LayerContent;
}

const DataLayerNavigationList = NavigationList.extend`
  ${NavigationLink} {
    white-space: normal;
  }
`;

const DataLayerContainer = ({ layer }: DataLayerContainerProps) => {
  const layerLeft = layer.left;
  const layerRight = layer.right;
  const layerMiddle = layer.middle;
  return (
    <DataLayer>
      <Row noGap>
        <Column>
          <NavigationHeader>
            {layerLeft && <HtmlContent htmlString={layerLeft.header || ''} />}
          </NavigationHeader>
        </Column>
      </Row>
      <Row noGap>
        <Column large={3}>
          <DataContent>
            {layerLeft && <HtmlContent htmlString={layerLeft.bodytext || ''} />}
          </DataContent>
        </Column>
        <Column large={6}>
          <DataContent>
            {layerMiddle && (
              <HtmlContent htmlString={layerMiddle.bodytext || ''} />
            )}
          </DataContent>
        </Column>
        <Column large={3}>
          <DataContent>
            <Navigation>
              <DataLayerNavigationList>
                {layerRight && layerRight.pages && (
                  <NavigationGroup entries={layerRight.pages} />
                )}
              </DataLayerNavigationList>
            </Navigation>
          </DataContent>
        </Column>
      </Row>
    </DataLayer>
  );
};

export default DataLayerContainer;
